import { Actions } from "@/shared/core/store/actions";
import { Getters } from "@/shared/core/store/getters";
import { Mutations } from "@/shared/core/store/mutations";
import { Booking } from "../model/Booking";
import { BookingConfiguration } from "../model/BookingConfiguration";
import { BookingState } from "../model/BookingState";
import { bookingsService } from "../services/bookings.service";
import { CompleteStats } from "../model/statistics/CompleteStats";
import { PeriodStats } from "../model/statistics/PeriodStats";
import { SlotStats } from "../model/statistics/SlotStats";

const bookingState: BookingState = {
  bookings: [],
  bookingConfiguration: null,
  bookingStatistics: null,
};

export const booking = {
  namespaced: true,
  state: bookingState,
  mutations: {
    [Mutations.SET_BOOKINGS]: (state: BookingState, bookings: Booking[]) => {
      state.bookings = bookings;
    },
    [Mutations.SET_BOOKING_CONFIGURATION]: (
      state: BookingState,
      bookingConfiguration: BookingConfiguration
    ) => {
      state.bookingConfiguration = bookingConfiguration;
    },
    [Mutations.SET_BOOKING_STATISTICS]: (
      state: BookingState, 
      bookingStatistics: CompleteStats
    ) => {
      state.bookingStatistics = bookingStatistics;
    },
    [Mutations.UPDATE_BOOKING_STATISTICS]: (
      state: BookingState, 
      updatedStatistics: { period: string; data: Partial<SlotStats>;}
    ) => { if(state.bookingStatistics){
      const periodStats = state.bookingStatistics.today.p1

      const updatedStats = periodStats.map((obj) => {
        return obj.slotIndex === updatedStatistics.data.slotIndex ? {... obj, ...updatedStatistics.data} : obj
      })

      state.bookingStatistics.today = {...state.bookingStatistics.today,  [updatedStatistics.period]: updatedStats};
    }
    },
  },
  actions: {
    // eslint-disable-next-line @typescript-eslint/ban-types
    [Actions.SET_BOOKINGS]: async ({ commit }: { commit: Function }, customerId: string) => {
      commit(Mutations.SET_BOOKINGS, await bookingsService.getBookings(customerId));
    },
    [Actions.SET_BOOKING_CONFIGURATION]: async (
      // eslint-disable-next-line @typescript-eslint/ban-types
      { commit }: { commit: Function },
      customerId: string
    ) => {
      commit(
        Mutations.SET_BOOKING_CONFIGURATION,
        (await bookingsService.getBookingConfiguration(customerId)) || null
      );
    },
    [Actions.SET_BOOKING_STATISTICS]: async (
      // eslint-disable-next-line @typescript-eslint/ban-types
      { commit }: { commit: Function },
      customerId: string
    ) => {
      if(await bookingsService.getBookingConfiguration(customerId)){
        commit(
          Mutations.SET_BOOKING_STATISTICS,
          (await bookingsService.getBookingStatistics(customerId)) || null
        );
      }
    },
    [Actions.UPDATE_BOOKING_STATISTICS]: async (
      // eslint-disable-next-line @typescript-eslint/ban-types
      { commit }: { commit: Function },
      updatedStatistics: Partial<SlotStats>
    ) => {
      commit(
        Mutations.UPDATE_BOOKING_STATISTICS,
        (updatedStatistics)
      );
    },
  },
  getters: {
    [Getters.BOOKINGS]: (state: BookingState): Booking[] => state.bookings,
    [Getters.BOOKING_CONFIGURATION]: (state: BookingState): BookingConfiguration | null =>
      state.bookingConfiguration,
    [Getters.BOOKING_STATISTICS]: (state: BookingState): CompleteStats | null =>
      state.bookingStatistics,
  },
};
